import { initFlagsAccount } from './flags-account'

export { FcsFlag, BcsFlag } from './unleash'
export { initUnleashFeatureFlags } from './unleash-config'
export {
  syncUnleashUserContext,
  clearUnleashUserContext
} from './unleash-context-sync'
export { FlagsAccount, isMyWhitelisted } from './flags-account'

export function initFlagsAccountBootstrap(): void {
  initFlagsAccount()
}
